import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-performance-report',
  templateUrl: './help-performance-report.component.html',
  styleUrls: ['./help-performance-report.component.scss']
})
export class HelpPerformanceReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
